import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const MONTH_NAMES = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

export default function MonthNav({ year, month, onChange, testId = "month-nav" }) {
  const prev = () => {
    if (month === 1) onChange(year - 1, 12);
    else onChange(year, month - 1);
  };
  const next = () => {
    if (month === 12) onChange(year + 1, 1);
    else onChange(year, month + 1);
  };
  return (
    <div className="flex items-center justify-center gap-3" data-testid={testId}>
      <Button variant="outline" size="icon" onClick={prev} data-testid={`${testId}-prev`}>
        <ChevronLeft className="w-4 h-4" />
      </Button>
      <p className="font-display font-bold text-lg min-w-[180px] text-center" data-testid={`${testId}-label`}>
        {MONTH_NAMES[month - 1]} {year}
      </p>
      <Button variant="outline" size="icon" onClick={next} data-testid={`${testId}-next`}>
        <ChevronRight className="w-4 h-4" />
      </Button>
    </div>
  );
}
